import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import { styled } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Skeleton from '@material-ui/lab/Skeleton';

export const Root = styled(Paper)({
  position: 'relative',
  width: '100%',
  height: 420,
  display: 'flex',
  flexDirection: 'column'
});

export const ContentArea = styled(Box)({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center'
});

export const Status = styled(Typography)({
  fontWeight: 600,
  textAlign: 'center'
});

export const Step = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(1),
  color: theme.palette.text.secondary,
  textAlign: 'center'
}));

export const HeaderSkeletonRoot = styled(Paper)(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.background.paper,
  display: 'flex',
  justifyContent: 'flex-start',
  padding: theme.spacing(3, 4),
  width: '100%'
}));

export const CellSkeleton = styled(Box)(({ theme }) => ({
  flex: 1,
  marginRight: theme.spacing(5),
  display: 'flex',
  alignItems: 'center',
  '&:last-child': {
    marginRight: 0
  }
}));

export const CircleSkeleton = styled(Skeleton)(({ theme }) => ({
  borderRadius: '50%',
  marginRight: theme.spacing(2.5)
}));
